module.exports = __webpack_public_path__ + "img/cusco.70520ce3.jpg";